var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: _vm.title,
            visible: _vm.visible,
            width: "40%",
            "modal-append-to-body": false,
            "append-to-body": "",
          },
          on: { close: _vm.handleClose },
        },
        [
          _c(
            "el-collapse",
            [
              _c(
                "el-collapse-item",
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "title-blue" }, [
                      _vm._v("\n            商品基础配置 "),
                      _c("i", { staticClass: "header-icon el-icon-info" }),
                    ]),
                  ]),
                  _c(
                    "div",
                    { staticClass: "bg-gray" },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "baseForm",
                          staticClass: "baseForm",
                          attrs: {
                            model: _vm.baseForm,
                            rules: _vm.baseFormRules,
                            disabled: _vm.optionType !== "add",
                            "label-width": "100px",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            { attrs: { prop: "goodsCode", label: "商品编号" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "99",
                                  size: "small",
                                  placeholder: "请输入商品编号",
                                },
                                model: {
                                  value: _vm.baseForm.goodsCode,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.baseForm, "goodsCode", $$v)
                                  },
                                  expression: "baseForm.goodsCode",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "goodsName", label: "商品名称" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "99",
                                  size: "small",
                                  placeholder: "请输入商品名称",
                                },
                                model: {
                                  value: _vm.baseForm.goodsName,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.baseForm, "goodsName", $$v)
                                  },
                                  expression: "baseForm.goodsName",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "partnerId", label: "联运方" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    clearable: "",
                                    size: "small",
                                    placeholder: "请选择联运方",
                                  },
                                  model: {
                                    value: _vm.baseForm.partnerId,
                                    callback: function ($$v) {
                                      _vm.$set(_vm.baseForm, "partnerId", $$v)
                                    },
                                    expression: "baseForm.partnerId",
                                  },
                                },
                                _vm._l(
                                  _vm.initData.partnerList,
                                  function (item) {
                                    return _c("el-option", {
                                      key: item.value,
                                      attrs: {
                                        label: item.label,
                                        value: item.value,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "partnerProductId",
                                label: "联运产品ID",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "99",
                                  size: "small",
                                  placeholder: "请输入联运产品ID",
                                },
                                model: {
                                  value: _vm.baseForm.partnerProductId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.baseForm,
                                      "partnerProductId",
                                      $$v
                                    )
                                  },
                                  expression: "baseForm.partnerProductId",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "partnerGoodsId",
                                label: "联运商品ID",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "99",
                                  size: "small",
                                  placeholder: "请输入联运商品ID",
                                },
                                model: {
                                  value: _vm.baseForm.partnerGoodsId,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.baseForm,
                                      "partnerGoodsId",
                                      $$v
                                    )
                                  },
                                  expression: "baseForm.partnerGoodsId",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
              _c(
                "el-collapse-item",
                [
                  _c("template", { slot: "title" }, [
                    _c("div", { staticClass: "title-blue" }, [
                      _vm._v("\n            商品展示配置 "),
                      _c("i", { staticClass: "header-icon el-icon-info" }),
                    ]),
                  ]),
                  _c(
                    "el-form",
                    {
                      ref: "showForm",
                      staticClass: "showForm",
                      attrs: {
                        model: _vm.showForm,
                        rules: _vm.showFormFormRules,
                        "label-width": "120px",
                        "validate-on-rule-change": false,
                      },
                    },
                    [
                      _c(
                        "div",
                        { staticClass: "bg-gray" },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "leboMemberGoodsIds",
                                label: "关联乐播会员",
                              },
                            },
                            [
                              _c("el-cascader", {
                                ref: "memberCascader",
                                attrs: {
                                  options: _vm.initData.memberGoods,
                                  props: { multiple: true },
                                  "collapse-tags": "",
                                  clearable: "",
                                  size: "small",
                                  separator: "-",
                                },
                                on: { change: _vm.uniteMemberChange },
                                model: {
                                  value: _vm.showForm.leboMemberGoodsIds,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.showForm,
                                      "leboMemberGoodsIds",
                                      $$v
                                    )
                                  },
                                  expression: "showForm.leboMemberGoodsIds",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            _vm._l(_vm.memberGoodsTag, function (item) {
                              return _c(
                                "el-tag",
                                {
                                  key: item.id,
                                  staticStyle: { "margin-right": "5px" },
                                  attrs: {
                                    closable: "",
                                    "disable-transitions": false,
                                  },
                                  on: {
                                    close: function ($event) {
                                      return _vm.tagsClosed(item)
                                    },
                                  },
                                },
                                [
                                  _vm._v(
                                    "\n                " +
                                      _vm._s(item.label) +
                                      "\n              "
                                  ),
                                ]
                              )
                            }),
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "销售端类型",
                                prop: "saleChannelList",
                              },
                            },
                            [
                              _c(
                                "el-button",
                                {
                                  attrs: { size: "small" },
                                  on: { click: _vm.addSaleItem },
                                },
                                [_vm._v("添加销售端")]
                              ),
                            ],
                            1
                          ),
                          _vm._l(
                            _vm.showForm.saleChannelList,
                            function (item, index) {
                              return _c(
                                "div",
                                { key: item, staticClass: "saleType-flex" },
                                [
                                  _c(
                                    "div",
                                    { staticClass: "flex" },
                                    [
                                      _c(
                                        "el-form-item",
                                        {
                                          staticClass: "saleType-class",
                                          attrs: {
                                            prop: `saleChannelList.${index}.clientType`,
                                          },
                                        },
                                        [
                                          _c(
                                            "el-select",
                                            {
                                              staticStyle: {
                                                width: "150px",
                                                "margin-right": "10px",
                                              },
                                              attrs: {
                                                clearable: "",
                                                size: "small",
                                                placeholder: "选择销售端类型",
                                              },
                                              model: {
                                                value: item.clientType,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    item,
                                                    "clientType",
                                                    $$v
                                                  )
                                                },
                                                expression: "item.clientType",
                                              },
                                            },
                                            _vm._l(
                                              _vm.initData.saleType,
                                              function (item) {
                                                return _c("el-option", {
                                                  key: item.value,
                                                  attrs: {
                                                    label: item.label,
                                                    value: item.value,
                                                    disabled: item.disabled,
                                                  },
                                                })
                                              }
                                            ),
                                            1
                                          ),
                                          _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                prop: `saleChannelList.${index}.channelType`,
                                              },
                                            },
                                            [
                                              _c(
                                                "el-select",
                                                {
                                                  staticStyle: {
                                                    width: "150px",
                                                    "margin-right": "10px",
                                                  },
                                                  attrs: {
                                                    clearable: "",
                                                    size: "small",
                                                    placeholder:
                                                      "请选择渠道类型",
                                                  },
                                                  on: {
                                                    change: function ($event) {
                                                      return _vm.channelTypeChange(
                                                        $event,
                                                        item
                                                      )
                                                    },
                                                  },
                                                  model: {
                                                    value: item.channelType,
                                                    callback: function ($$v) {
                                                      _vm.$set(
                                                        item,
                                                        "channelType",
                                                        $$v
                                                      )
                                                    },
                                                    expression:
                                                      "item.channelType",
                                                  },
                                                },
                                                _vm._l(
                                                  _vm.initData.channelType,
                                                  function (item) {
                                                    return _c("el-option", {
                                                      key: item.value,
                                                      attrs: {
                                                        label: item.label,
                                                        value: item.value,
                                                      },
                                                    })
                                                  }
                                                ),
                                                1
                                              ),
                                            ],
                                            1
                                          ),
                                          _c(
                                            "el-button",
                                            {
                                              staticStyle: { color: "#ff0000" },
                                              attrs: {
                                                type: "text",
                                                icon: "el-icon-delete",
                                              },
                                              on: {
                                                click: function ($event) {
                                                  _vm.showForm.saleChannelList =
                                                    _vm.showForm.saleChannelList.filter(
                                                      (i) => i !== item
                                                    )
                                                },
                                              },
                                            },
                                            [_vm._v("删除")]
                                          ),
                                        ],
                                        1
                                      ),
                                    ],
                                    1
                                  ),
                                  _c(
                                    "div",
                                    [
                                      item.channelType !== 1 &&
                                      item.channelType !== ""
                                        ? _c(
                                            "el-form-item",
                                            {
                                              attrs: {
                                                label: "指定渠道",
                                                prop: `saleChannelList.${index}.channelIds`,
                                              },
                                            },
                                            [
                                              _c("el-input", {
                                                attrs: { type: "textarea" },
                                                on: {
                                                  focus: function ($event) {
                                                    return _vm.channelInputClick(
                                                      item
                                                    )
                                                  },
                                                },
                                                model: {
                                                  value: item.channelNames,
                                                  callback: function ($$v) {
                                                    _vm.$set(
                                                      item,
                                                      "channelNames",
                                                      $$v
                                                    )
                                                  },
                                                  expression:
                                                    "item.channelNames",
                                                },
                                              }),
                                              _c("channel-popups", {
                                                attrs: {
                                                  isAppendToBody: true,
                                                  modelIsAppendToBody: false,
                                                  "app-id": item.channelIds,
                                                  visible: item.channelVisible,
                                                  multiple: true,
                                                },
                                                on: {
                                                  "update:visible": function (
                                                    $event
                                                  ) {
                                                    return _vm.$set(
                                                      item,
                                                      "channelVisible",
                                                      $event
                                                    )
                                                  },
                                                  comfirm: function ($event) {
                                                    return _vm.channelConfirm(
                                                      $event,
                                                      item
                                                    )
                                                  },
                                                },
                                              }),
                                            ],
                                            1
                                          )
                                        : _vm._e(),
                                    ],
                                    1
                                  ),
                                ]
                              )
                            }
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "前端可见",
                                prop: "frontVisible",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.showForm.frontVisible,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.showForm,
                                        "frontVisible",
                                        $$v
                                      )
                                    },
                                    expression: "showForm.frontVisible",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: true } }, [
                                    _vm._v("是"),
                                  ]),
                                  _c("el-radio", { attrs: { label: false } }, [
                                    _vm._v("否"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "显示顺序",
                                prop: "displayOrder",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "9999",
                                  size: "small",
                                  placeholder: "请输入显示顺序,从1开始",
                                },
                                model: {
                                  value: _vm.showForm.displayOrder,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.showForm, "displayOrder", $$v)
                                  },
                                  expression: "showForm.displayOrder",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: { label: "定价周期", prop: "salePeriod" },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  disabled: _vm.optionType !== "add",
                                  clearable: "",
                                  maxlength: "99",
                                  size: "small",
                                  placeholder: "请输入数字",
                                },
                                model: {
                                  value: _vm.showForm.salePeriod,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.showForm, "salePeriod", $$v)
                                  },
                                  expression: "showForm.salePeriod",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { prop: "salePeriodUnit" } },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    disabled: _vm.optionType !== "add",
                                    clearable: "",
                                    size: "small",
                                    placeholder: "请选择定价周期单位",
                                  },
                                  model: {
                                    value: _vm.showForm.salePeriodUnit,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.showForm,
                                        "salePeriodUnit",
                                        $$v
                                      )
                                    },
                                    expression: "showForm.salePeriodUnit",
                                  },
                                },
                                [
                                  _c("el-option", {
                                    attrs: { label: "日", value: 1 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "月", value: 2 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "季", value: 3 },
                                  }),
                                  _c("el-option", {
                                    attrs: { label: "年", value: 4 },
                                  }),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "售价", prop: "salePrice" } },
                            [
                              _c(
                                "div",
                                { staticStyle: { display: "flex" } },
                                [
                                  _c("el-input", {
                                    staticStyle: { width: "250px !important" },
                                    attrs: {
                                      disabled: _vm.optionType !== "add",
                                      clearable: "",
                                      maxlength: "99",
                                      size: "small",
                                      placeholder: "输入金额",
                                    },
                                    model: {
                                      value: _vm.showForm.salePrice,
                                      callback: function ($$v) {
                                        _vm.$set(_vm.showForm, "salePrice", $$v)
                                      },
                                      expression: "showForm.salePrice",
                                    },
                                  }),
                                  _vm._v(
                                    "\n                 元\n              "
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "限制购买次数",
                                prop: "limitPurchaseTimesFlag",
                              },
                            },
                            [
                              _c(
                                "el-radio-group",
                                {
                                  model: {
                                    value: _vm.showForm.limitPurchaseTimesFlag,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.showForm,
                                        "limitPurchaseTimesFlag",
                                        $$v
                                      )
                                    },
                                    expression:
                                      "showForm.limitPurchaseTimesFlag",
                                  },
                                },
                                [
                                  _c("el-radio", { attrs: { label: 0 } }, [
                                    _vm._v("不限制"),
                                  ]),
                                  _c("el-radio", { attrs: { label: 1 } }, [
                                    _vm._v("1次"),
                                  ]),
                                ],
                                1
                              ),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "Icon", prop: "goodsIcon" } },
                            [
                              _c(
                                "div",
                                { staticClass: "flex" },
                                [
                                  _vm.showForm.goodsIcon
                                    ? _c("el-image", {
                                        staticStyle: {
                                          width: "100px",
                                          "margin-right": "10px",
                                        },
                                        attrs: {
                                          src: _vm.showForm.goodsIcon,
                                          fit: "scale-down",
                                        },
                                      })
                                    : _vm._e(),
                                  _c(
                                    "el-upload",
                                    {
                                      attrs: {
                                        "before-upload": _vm.checkUpload,
                                        "http-request": _vm.upload,
                                        listType: "picture-img",
                                        "show-file-list": false,
                                      },
                                    },
                                    [
                                      _c(
                                        "el-button",
                                        {
                                          attrs: {
                                            size: "small",
                                            type: "primary",
                                          },
                                        },
                                        [_vm._v("上传图片")]
                                      ),
                                    ],
                                    1
                                  ),
                                ],
                                1
                              ),
                            ]
                          ),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                label: "短描述",
                                prop: "shortDescription",
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  clearable: "",
                                  maxlength: "9999",
                                  size: "small",
                                  placeholder: "请输入短描述",
                                },
                                model: {
                                  value: _vm.showForm.shortDescription,
                                  callback: function ($$v) {
                                    _vm.$set(
                                      _vm.showForm,
                                      "shortDescription",
                                      $$v
                                    )
                                  },
                                  expression: "showForm.shortDescription",
                                },
                              }),
                            ],
                            1
                          ),
                          _c(
                            "el-form-item",
                            { attrs: { label: "备注", prop: "remark" } },
                            [
                              _c("el-input", {
                                attrs: {
                                  type: "textarea",
                                  "show-limit-word": "",
                                  clearable: "",
                                  maxlength: "99999",
                                  size: "small",
                                  placeholder: "请输入备注",
                                },
                                model: {
                                  value: _vm.showForm.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.showForm, "remark", $$v)
                                  },
                                  expression: "showForm.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        2
                      ),
                      _c(
                        "el-form-item",
                        { attrs: { label: "商品状态", prop: "state" } },
                        [
                          _c(
                            "el-radio-group",
                            {
                              model: {
                                value: _vm.showForm.state,
                                callback: function ($$v) {
                                  _vm.$set(_vm.showForm, "state", $$v)
                                },
                                expression: "showForm.state",
                              },
                            },
                            [
                              _c("el-radio", { attrs: { label: 1 } }, [
                                _vm._v("生效"),
                              ]),
                              _c("el-radio", { attrs: { label: 0 } }, [
                                _vm._v("失效"),
                              ]),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                2
              ),
            ],
            1
          ),
          _c(
            "span",
            {
              staticClass: "dialog-footer",
              attrs: { slot: "footer" },
              slot: "footer",
            },
            [
              _c(
                "el-button",
                { attrs: { size: "small" }, on: { click: _vm.handleClose } },
                [_vm._v("取消")]
              ),
              _c(
                "el-button",
                {
                  attrs: { size: "small", type: "primary" },
                  on: { click: _vm.handleSave },
                },
                [_vm._v("保存")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }